module.exports = __webpack_public_path__ + "img/NewVehicleIcon.e77e082b.svg";